import { useState } from "react";
import { ChevronDown, LogOut, Settings, User } from "lucide-react";
import ProfileModal from "./ProfileModal";
import PasswordChangeModal from "./PasswordChangeModal";
import { useAuth } from "../../../features/users/context/AuthContext";

const UserDropdown = ({ user, onLogout,  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const { user: contextUser } = useAuth();
    
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleProfileClick = (e) => {
      e.preventDefault();
      setShowProfileModal(true);
      setIsOpen(false);
    };

    const handlePasswordClick = (e) => {
      e.preventDefault();
      setShowPasswordModal(true);
      setIsOpen(false);
    };

    const handleProfileUpdateSuccess = () => {
      // Optionnel : actualiser le contexte utilisateur
      window.location.reload(); // Simple solution pour actualiser les données
    };
    
    // Extraction des initiales du nom et prénom
    const getInitials = () => {
        if (!user || !user?.firstname || !user?.lastname) return "?";
        const nomInitial = user.firstname.charAt(0);
        const prenomInitial = user.lastname.charAt(0);
        return `${nomInitial}${prenomInitial}`.toUpperCase();
      };
  
    return (
      <div className="relative me-10">
        <button
          onClick={toggleDropdown}
          className="flex items-center space-x-2 focus:outline-none"
        >
          <div className="h-8 w-8 rounded-full bg-green-600 flex items-center justify-center text-white font-medium">
            {getInitials()}
          </div>
         
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </button>
  
        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-40 py-1 border border-gray-200">
            <div className="px-4 py-2 text-xs text-gray-500 border-b border-gray-200">
              
              <span className="font-medium text-gray-800">{user?.firstname } {user?.lastname }</span>
            </div>
            
            <button 
              onClick={handleProfileClick}
              className="flex w-full  ps-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Modifier mon profil
            </button>
            
            <button 
              onClick={handlePasswordClick}
              className="flex w-full  ps-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Modifier mon mot de passe
            </button> 
            
            <div className="border-t border-gray-200"></div>
            
            <button 
              onClick={onLogout}
              className="flex w-full  ps-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </button>
            
          
          </div>
        )}

        {/* Modaux */}
        <ProfileModal 
          isOpen={showProfileModal}
          onClose={() => setShowProfileModal(false)}
          user={contextUser || user}
          onUpdateSuccess={handleProfileUpdateSuccess}
        />
        
        <PasswordChangeModal 
          isOpen={showPasswordModal}
          onClose={() => setShowPasswordModal(false)}
          user={contextUser || user}
        />
      </div>
    );
  };
  
  export default UserDropdown;